import React, { useContext } from "react";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const columns = [
  { field: "id_titular", header: "ID", width: "8rem" },
  { field: "nombre_razonsocial", header: "Nombre" },
  { field: "numerodocumento", header: "C.U.I.T." },
  { field: "domicilio", header: "Domicilio" },
  { field: "localidad", header: "Localidad" },
  { field: "telefono1", header: "Teléfono" },
  { field: "habilitado", header: "Habilitado", type: "bool", width: "9rem" },
];

export default function Convenios() {
  const {
    convenios,
    localidades,
    obtenerConvenios,
    obtenerLocalidades,
    agregarConvenio,
    actualizarConvenio,
  } = useContext(ConfiguracionContext);

  const fields = [
    {
      name: "nombre_razonsocial",
      label: "Nombre",
      type: "text",
      required: true,
      md: 12,
    },
    {
      name: "numerodocumento",
      label: "C.U.I.T",
      type: "text",
      required: true,
      requiredMsg: "La C.U.I.T. es necesaria !.",
      md: 3,
    },
    {
      name: "domicilio",
      label: "Domicilio",
      type: "text",
      required: true,
      requiredMsg: "El domicilio es necesario !.",
      md: 9,
    },
    {
      name: "localidadId",
      label: "Localidad",
      type: "select",
      required: true,
      requiredMsg: "La localidad es necesario !.",
      options: localidades || [],
      optionLabel: "nombre",
      optionValue: "id",
      labelField: "localidad", // guarda también el nombre en convenio.localidad
      md: 6,
    },
    { name: "telefono1", label: "Teléfono", type: "text", md: 6 },
    { name: "habilitado", label: "Habilitado", type: "switch", md: 12 },
  ];

  return (
    <MaestroArchivo
      titulo="Carga de Convenios"
      entidad="convenio"
      layout="Convenios"
      icono={<HandshakeOutlinedIcon />}
      items={convenios}
      idKey="id_titular"
      listo={Boolean(localidades)}
      columns={columns}
      fields={fields}
      nuevoDefault={{
        nombre_razonsocial: "",
        numerodocumento: "",
        domicilio: "",
        localidadId: null,
        localidad: "",
        telefono1: "",
        habilitado: true,
      }}
      onMount={() => obtenerLocalidades()}
      onObtener={() => obtenerConvenios()}
      onAgregar={(data) => agregarConvenio({ convenio: data })}
      onActualizar={(data) => actualizarConvenio({ convenio: data })}
    />
  );
}
